'use strict'

const messages = {
  ru: {
    common: {
      develop: 'Разработано',
      repeat: 'Попробовать еще',
      dataEmpty: 'Данные отсутствуют',
      talon: 'Талон №',
      windowNumber: 'Окно',
      status: 'Статус',
      makeConnection: 'Устанавливаем соединение',
      emptyClients: 'Клиенты отсутствуют',
      client: 'Клиент'
    },
    logout: {
      action: {
        primary: 'Выйти'
      }
    },
    auth: {
      title: 'Вход в кабинет',
      subtitle: 'Пожалуйста, авторизуйтесь',
      action: {
        primary: 'Войти'
      },
      fields: {
        login: {
          placeholder: 'ID табло'
        },
        password: {
          placeholder: 'Api-ключ'
        },
        error: {
          emptyValue: ''
        }
      }
    },
    ticket: {
      state: {
        NEED_EXTRA_INFO: 'Требуется доп. информация',
        READY: 'Готов для постановки в очередь',
        CALL: 'Вызван',
        SERVICE_IN_PROCESS: 'Обслуживается',
        SERVICE_FINISH: 'Обслужен',
        NO_SERVICE: 'Не обслужен',
        REJECTION: 'Отказ',
        UNKNOWN: 'Неизвестно'
      },
      title: 'Очередь',
      empty: 'Нет талонов',
      tableName: '№<br>стола',
      ticketName: 'Талон'
    },
    error: {
      accessDenied1: 'Доступ запрещен, пробуем восстановить соединение',
      accessDenied2: 'Если ошибка не&nbsp;исчезает, попробуйте авторизоваться заново',
      socketConnect: 'Ошибка подключения к сокету',
      loading: 'Ошибка загрузки данных',
      unknown: 'Неизвестная ошибка'
    },
    lockScreen: {
      old: {
        title: 'Вы используете устаревшую версию браузера',
        subtitle: 'Пожалуйста, обновите Ваш браузер',
        subtitleChrome: 'Baш браузер: Google Chrome',
        subtitleFirefox: 'Baш браузер: Mozilla Firefox',
        errorChrome: 'Минимальная версия: Google Chrome 80',
        errorFirefox: 'Минимальная версия: Mozilla Firefox 75'
      },
      notSupport: {
        title: 'Ваш браузер не поддерживается',
        error: {
          title: 'Используйте один из следующих:',
          desc: 'Google Chrome 80 или более поздней версии<br>Mozilla Firefox 75 или более поздней версии'
        }
      }
    }
  }
}

export default messages
